import type {RouterConfig} from '@nuxt/schema'

export default <RouterConfig>{
  routes: (_routes) => {
    const routes = _routes.filter(r => r.extended === true)
    return routes
  }
}
